import { forwardRef } from 'react';
import MaterialClickAwayListener, {
    ClickAwayListenerProps,
} from '@mui/material/ClickAwayListener';

export const ClickAwayListener = forwardRef<
    HTMLDivElement,
    ClickAwayListenerProps
>((props, ref) => {
    return (
        <MaterialClickAwayListener
            ref={ref}
            data-testid={'ClickAwayListener-container'}
            {...props}
        />
    );
});

export default ClickAwayListener;
